var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hide-on-print"},[_c('v-footer',{staticClass:"d-flex justify-space-around align-center transparent"},[_c('i',{staticClass:"text-center",domProps:{"textContent":_vm._s('Copyright ©'+new Date().getFullYear()+' LoesusPedagogia')}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }